import React, { useState } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons"

import Icon from "../layout/icon"
import { InlineText } from "../Typography/Typography"

import {
  body as bodyStyle,
  button,
  closed,
  icon,
  iconLabel,
  open as openStyle,
  reveal,
  showChevronNextToTitle as showChevronNextToTitleStyle,
} from "./styles.module.scss"

const IconWrapper = ({ showLabel, open }) => {
  if (showLabel) {
    return (
      <InlineText brand>
        <span className={classNames(iconLabel)}>{open ? "Hide" : "Show"}</span>
        <Icon icon={open ? faChevronUp : faChevronDown} />
      </InlineText>
    )
  }

  return (
    <Icon
      icon={open ? faChevronUp : faChevronDown}
      className={classNames(icon)}
    />
  )
}

const Title = ({ title, titleOnOpen, open }) => {
  if (!titleOnOpen) {
    return title
  }
  return open ? titleOnOpen : title
}

export default function Reveal({
  children: [title, body],
  onOpen,
  onClose,
  showLabel,
  extraClasses,
  onFirstOpen,
  titleOnOpen,
  showChevronNextToTitle,
}) {
  const [open, setOpen] = useState(false)
  const [hasBeenOpened, setHasBeenOpened] = useState(false)
  const onToggle = open ? onClose : onOpen
  const toggleOpen = () => setOpen(!open)
  const setHasBeenOpenedTrue = () => setHasBeenOpened(true)
  const fireOnFirstOpen = () => hasBeenOpened || onFirstOpen()

  const handleToggle = () => {
    toggleOpen()
    fireOnFirstOpen()
    setHasBeenOpenedTrue()
    onToggle()
  }

  return (
    <div className={reveal}>
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <button
        className={classNames(button, extraClasses, {
          [showChevronNextToTitleStyle]: showChevronNextToTitle,
        })}
        type="button"
        onClick={handleToggle}
      >
        <Title title={title} titleOnOpen={titleOnOpen} open={open} />
        <IconWrapper showLabel={showLabel} open={open} />
      </button>
      <div
        className={classNames(bodyStyle, {
          [openStyle]: open,
          [closed]: !open,
        })}
      >
        {body}
      </div>
    </div>
  )
}

Reveal.propTypes = {
  children: PropTypes.node.isRequired,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  showLabel: PropTypes.bool,
  extraClasses: PropTypes.string,
  onFirstOpen: PropTypes.func,
  titleOnOpen: PropTypes.node,
  showChevronNextToTitle: PropTypes.bool,
}

Reveal.defaultProps = {
  onOpen: () => null,
  onClose: () => null,
  showLabel: false,
  extraClasses: undefined,
  onFirstOpen: () => {},
  titleOnOpen: undefined,
  showChevronNextToTitle: false,
}

IconWrapper.propTypes = {
  showLabel: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
}

Title.propTypes = {
  title: PropTypes.node.isRequired,
  titleOnOpen: PropTypes.node,
  open: PropTypes.bool.isRequired,
}

Title.defaultProps = {
  titleOnOpen: undefined,
}
